import { Validation } from '../Validation/Validation';
import { BaseFormState } from '~/types/BaseFormState';
import { FormState } from 'react-hook-form';
import { PropsWithChildren } from 'react';
import styles from './Group.module.css';
import { Label } from '../Label/Label';

type Props<TFormState extends BaseFormState> = PropsWithChildren & {
  formState?: FormState<TFormState>;
  htmlFor: keyof TFormState;
  label?: string;
  tooltip?: string;
};

export function Group<TFormState extends BaseFormState>(props: Props<TFormState>) {
  const { formState, children, htmlFor, label, tooltip } = props;

  return (
    <div className={styles.group}>
      <Label htmlFor={htmlFor} label={label} tooltip={tooltip} />
      <div className={styles.content}>{children}</div>
      <Validation htmlFor={htmlFor} formState={formState} />
    </div>
  );
}
